// Rather than passing event handlers down across multiple levels (e.g. for onLogin), I'll probably increasingly move to this arrangement.
import cloudFunctionProxy from "../cloudFunctionProxy";
import React from "react";

export interface ReviewContext {
  onToggleExplanation(isExplanationExpanded: boolean, cardID: string, promptIndex: number | null): any;
}

export const networkedReviewContext: ReviewContext = {
  onToggleExplanation: async (isExplanationExpanded, cardID, promptIndex) => {
    await cloudFunctionProxy.didToggleExplanation({isExplanationExpanded, cardID, promptIndex});
  }
};

export const ReviewContext = React.createContext(networkedReviewContext);

